import React from 'react';
import { Select } from 'antd';
import { Calendar, Filter } from 'lucide-react';

interface FilterPanelProps {
  onYearChange: (year: number | null) => void;
  onMonthChange: (month: number | null) => void;
  availableYears: number[];
  availableMonths: { value: number; label: string }[];
  selectedYear: number | null;
  selectedMonth: number | null;
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
  onYearChange,
  onMonthChange,
  availableYears,
  availableMonths,
  selectedYear,
  selectedMonth,
}) => {
  return (
    <div className="flex gap-4 px-4 py-1 bg-white rounded-lg shadow-sm border border-light-grey h-full items-center">
      <div className="flex items-center gap-1.5">
        <div className="h-[18px] w-[18px] bg-light-grey rounded flex items-center justify-center">
          <Filter className="h-3 w-3 text-primary" />
        </div>
        <h3 className="text-dark-blue heading-7">Filters</h3>
      </div>
      
      <div className="flex items-center gap-2">
        <div className="h-[18px] w-[18px] bg-light-grey rounded flex items-center justify-center">
          <Calendar className="h-3 w-3 text-dark-grey" />
        </div>
        <span className="paragraph-12 text-dark-grey">Year:</span>
        <Select
          value={selectedYear}
          onChange={onYearChange}
          options={[
            { value: null, label: 'All' },
            ...availableYears.map(year => ({ value: year, label: year.toString() }))
          ]}
          style={{ width: 100 }}
          className="text-xs"
          placeholder="Select year"
          size="small"
        />
      </div>
      <div className="flex items-center gap-2">
        <span className="paragraph-12 text-dark-grey">Month:</span>
        <Select
          value={selectedMonth}
          onChange={onMonthChange}
          options={[
            { value: null, label: 'All' },
            ...availableMonths
          ]}
          style={{ width: 120 }}
          className="text-xs"
          placeholder="Select month"
          disabled={!selectedYear}
          size="small"
        />
      </div>
    </div>
  );
};